import classNames from "classnames";
import * as React from "react";

import styles from "./TextInput.module.css";

/** Control density: drives the input's height, padding, and font size. */
export type TextInputSize = "sm" | "md" | "lg";

const sizeClass: Record<TextInputSize, string> = {
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg,
};

/**
 * A native input's props, with `size` taken over for density: the native
 * attribute (a width in characters) is not something a form here sets.
 */
export interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  /**
   * Height, padding, and font size, on the same scale as `Select` and
   * `Combobox` so fields of one size line up.
   * @default "md"
   */
  size?: TextInputSize;
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput({ className, size = "md", ...props }, ref) {
    return (
      <input
        ref={ref}
        className={classNames(styles.input, sizeClass[size], className)}
        {...props}
      />
    );
  },
);
